/* ==========================================================================
   Dante Furniture — product page V3 behaviour (df-pdp.js)
   Gallery + lightbox, drawers, variants, mattress add-on, AJAX add to basket
   (bed + mattresses in one request, opens the theme cart drawer), finance
   calculator, sticky buy box and sticky Add-to-Basket bar, recommendations.
   ========================================================================== */
(function () {
  'use strict';
  if (window.DFPDP) return;

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var behaviour = function (smooth) { return smooth === false || reduceMotion ? 'auto' : 'smooth'; };

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function decodeEntities(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value;
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || '£{{amount}}';
    function delimit(number, precision, thousands, decimal) {
      var parts = (number / 100).toFixed(precision).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  function moneyShort(cents, format) {
    var s = formatMoney(cents, format);
    return Math.round(cents) % 100 === 0 ? s.replace(/[.,]00(?!\d)/, '') : s;
  }

  function stickyHeaderHeight() {
    return parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height')) || 0;
  }
  function scrollToEl(el) {
    var y = el.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() - 16;
    window.scrollTo({ top: Math.max(0, y), behavior: behaviour(true) });
  }
  function lockScroll(on) {
    document.documentElement.classList.toggle('dfp-lock', !!on);
  }
  function focusables(container) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), iframe, [tabindex]:not([tabindex="-1"])', container)
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
  }
  function trapTab(e, container) {
    var f = focusables(container);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !container.contains(document.activeElement))) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !container.contains(document.activeElement))) {
      e.preventDefault(); first.focus();
    }
  }

  /* ==========================================================================
     Drawer manager (one open at a time)
     ========================================================================== */
  var Lightbox = { isOpen: false };
  var Drawer = {
    current: null,
    opener: null,
    open: function (el, opener) {
      if (!el) return;
      if (this.current && this.current !== el) this.close(true);
      this.current = el;
      this.opener = opener || document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      var panel = qs('.dfp-drawer__panel', el) || el;
      setTimeout(function () {
        try { panel.focus({ preventScroll: true }); } catch (err) { panel.focus(); }
      }, 40);
      el.dispatchEvent(new CustomEvent('dfp:drawer:open', { bubbles: true, detail: { opener: opener } }));
    },
    close: function (silent) {
      var el = this.current;
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      this.current = null;
      if (!Lightbox.isOpen) lockScroll(false);
      el.dispatchEvent(new CustomEvent('dfp:drawer:close', { bubbles: true }));
      var opener = this.opener;
      this.opener = null;
      if (!silent && opener && typeof opener.focus === 'function' && document.contains(opener)) {
        try { opener.focus({ preventScroll: true }); } catch (err) { opener.focus(); }
      }
    }
  };

  function openChat(fallbackPhone) {
    Drawer.close(true);
    var api = window.tidioChatApi;
    if (api && typeof api.open === 'function') {
      if (typeof api.show === 'function') api.show();
      api.open();
      return;
    }
    if (fallbackPhone) window.location.href = 'tel:' + fallbackPhone.replace(/\s+/g, '');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-dfp-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-dfp-open'));
      if (d) { e.preventDefault(); Drawer.open(d, opener); }
      return;
    }
    var closer = t.closest('[data-dfp-close]');
    if (closer && Drawer.current && Drawer.current.contains(closer)) {
      e.preventDefault();
      Drawer.close();
      return;
    }
    var chat = t.closest('[data-dfp-chat]');
    if (chat) {
      e.preventDefault();
      var tel = qs('.dfp-contact__btn[href^="tel:"]');
      openChat(tel ? tel.getAttribute('href').replace('tel:', '') : '');
      return;
    }
    var rev = t.closest('[data-dfp-scroll-reviews]');
    if (rev) {
      var target = document.getElementById('reviews') || document.getElementById('looxReviews');
      if (target) { e.preventDefault(); scrollToEl(target); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (Lightbox.isOpen || !Drawer.current) return;
    if (e.key === 'Escape') { e.preventDefault(); Drawer.close(); }
    else if (e.key === 'Tab') trapTab(e, Drawer.current);
  });

  /* ==========================================================================
     Size helpers (mattress matching)
     ========================================================================== */
  function normSize(s) {
    s = String(s || '').toLowerCase().replace(/\s+/g, ' ');
    if (/super ?king/.test(s)) return 'super king';
    if (/small ?double/.test(s)) return 'small double';
    if (/small ?single/.test(s)) return 'small single';
    if (/king/.test(s)) return 'king';
    if (/double/.test(s)) return 'double';
    if (/single/.test(s)) return 'single';
    if (/6 ?ft/.test(s)) return 'super king';
    if (/5 ?ft/.test(s)) return 'king';
    if (/4 ?ft ?6|4'6/.test(s)) return 'double';
    if (/4 ?ft/.test(s)) return 'small double';
    if (/3 ?ft/.test(s)) return 'single';
    if (/2 ?ft ?6/.test(s)) return 'small single';
    return '';
  }
  function prettySize(title) {
    return String(title || '').replace(/FT/g, 'ft').replace(/\s*-\s*/, ' ');
  }

  /* ==========================================================================
     Mattress add-on
     ========================================================================== */
  function Mattress(product, block, drawer) {
    var self = this;
    this.p = product;
    this.block = block;
    this.drawer = drawer;
    this.pct = parseFloat(block.getAttribute('data-pct')) || 0;
    this.perBed = parseInt(block.getAttribute('data-per-bed'), 10) || 1;
    this.slots = {};
    this.slotEls = {};
    this.order = [];
    qsa('[data-dfp-mat-slot]', block).forEach(function (el) {
      var key = el.getAttribute('data-dfp-mat-slot');
      self.slotEls[key] = el;
      self.order.push(key);
    });
    this.msg = qs('[data-dfp-mat-msg]', block);
    this.title = qs('[data-dfp-mat-title]', drawer);
    this.note = qs('[data-dfp-mat-note]', drawer);
    this.topNote = qs('[data-dfp-mat-topnote]', drawer);
    this.forLabel = qs('[data-dfp-mat-for]', drawer);
    this.cards = qsa('[data-dfp-mat-card]', drawer).map(function (el) {
      var variants = [];
      try { variants = JSON.parse(qs('[data-dfp-mat-variants]', el).textContent); } catch (err) { variants = []; }
      return { el: el, variants: variants, title: el.getAttribute('data-title') || '', img: el.getAttribute('data-img') || '', match: null };
    });
    this.activeSlot = this.order[0] || 'single';

    qsa('[data-dfp-mat-open]', block).forEach(function (btn) {
      btn.addEventListener('click', function () { self.open(btn.getAttribute('data-dfp-mat-open'), btn); });
    });
    qsa('[data-dfp-mat-remove]', block).forEach(function (btn) {
      btn.addEventListener('click', function () { self.remove(btn.getAttribute('data-dfp-mat-remove')); });
    });
    this.cards.forEach(function (c) {
      var add = qs('[data-dfp-mat-add]', c.el);
      if (add) add.addEventListener('click', function () { self.choose(c); });
    });
    qsa('[data-dfp-mat-filter]', drawer).forEach(function (chip) {
      chip.addEventListener('click', function () { self.filter(chip); });
    });
    this.updateCards();
    this.render();
  }

  Mattress.prototype.money = function (c) { return this.p.money(c); };
  Mattress.prototype.sizeLabel = function () {
    var p = this.p;
    var label = '';
    if (p.data.sizeIndex >= 0 && p.variant) label = p.variant.options[p.data.sizeIndex];
    return label || p.data.sizeLabel || '';
  };
  Mattress.prototype.findVariant = function (card, key) {
    var found = null;
    if (!key) {
      if (card.variants.length === 1 && card.variants[0].available) return card.variants[0];
      return null;
    }
    card.variants.forEach(function (v) {
      if (found || !v.available) return;
      var hit = (v.options || []).some(function (o) { return normSize(o) === key; }) || normSize(v.title) === key;
      if (hit) found = v;
    });
    return found;
  };
  Mattress.prototype.filled = function () {
    var self = this;
    return this.order.filter(function (k) { return !!self.slots[k]; });
  };
  /* Which filled slots get the bundle saving: cheapest first, perBed x bed qty */
  Mattress.prototype.discountedSet = function () {
    var self = this;
    var allowance = this.perBed * this.p.getQty();
    var keys = this.filled().slice().sort(function (a, b) { return self.slots[a].variant.price - self.slots[b].variant.price; });
    var set = {};
    keys.forEach(function (k, i) { if (i < allowance && self.pct > 0) set[k] = true; });
    return set;
  };
  Mattress.prototype.wouldDiscount = function (slot) {
    if (this.pct <= 0) return false;
    var allowance = this.perBed * this.p.getQty();
    var others = this.filled().filter(function (k) { return k !== slot; }).length;
    return others < allowance;
  };
  Mattress.prototype.unitPrice = function (price, discounted) {
    return discounted ? Math.round(price * (100 - this.pct) / 100) : price;
  };
  Mattress.prototype.total = function (qty) {
    var self = this;
    var set = this.discountedSet();
    return this.filled().reduce(function (sum, k) {
      return sum + self.unitPrice(self.slots[k].variant.price, !!set[k]) * (qty || 1);
    }, 0);
  };
  Mattress.prototype.items = function (qty) {
    var self = this;
    return this.filled().map(function (k) {
      var item = { id: self.slots[k].variant.id, quantity: qty || 1 };
      if (k === 'top' || k === 'bottom') item.properties = { 'Mattress for': k === 'top' ? 'Top bunk' : 'Bottom bunk' };
      return item;
    });
  };
  Mattress.prototype.open = function (slot, opener) {
    this.activeSlot = slot;
    var el = this.slotEls[slot];
    if (this.title && el) this.title.textContent = el.getAttribute('data-label') || this.title.textContent;
    if (this.topNote) this.topNote.hidden = slot !== 'top';
    if (this.note) {
      var other = this.filled().filter(function (k) { return k !== slot; }).length;
      var showNote = this.pct > 0 && !this.wouldDiscount(slot) && other > 0;
      this.note.hidden = !showNote;
      if (showNote) this.note.textContent = 'Your ' + this.pct + '% mattress saving applies to ' + (this.perBed === 1 ? 'one mattress' : this.perBed + ' mattresses') + ' per bed and is already on your other mattress, so this one is full price.';
    }
    if (this.forLabel) {
      var lbl = this.sizeLabel();
      this.forLabel.textContent = lbl ? 'for your ' + lbl + ' bed' : '';
    }
    this.updateCards();
    Drawer.open(this.drawer, opener);
  };
  Mattress.prototype.updateCards = function () {
    var self = this;
    var key = normSize(this.sizeLabel());
    var discounted = this.wouldDiscount(this.activeSlot);
    this.cards.forEach(function (c) {
      var v = self.findVariant(c, key);
      c.match = v;
      var priceEl = qs('[data-dfp-mat-price]', c.el);
      var wasEl = qs('[data-dfp-mat-was]', c.el);
      var saveEl = qs('[data-dfp-mat-save]', c.el);
      var sizeEl = qs('[data-dfp-mat-size]', c.el);
      var naEl = qs('[data-dfp-mat-na]', c.el);
      var add = qs('[data-dfp-mat-add]', c.el);
      if (v) {
        var price = self.unitPrice(v.price, discounted);
        if (priceEl) priceEl.textContent = self.money(price);
        var showWas = discounted && self.pct > 0;
        if (wasEl) {
          wasEl.hidden = !showWas;
          var s = qs('s', wasEl);
          if (s) s.textContent = self.money(v.price);
        }
        if (saveEl) {
          saveEl.hidden = !showWas;
          if (showWas) saveEl.textContent = 'Save ' + moneyShort(v.price - price, self.p.fmt);
        }
        if (sizeEl) sizeEl.textContent = prettySize(v.title);
        if (naEl) naEl.hidden = true;
      } else {
        if (wasEl) wasEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
        if (sizeEl) sizeEl.textContent = '';
        if (naEl) naEl.hidden = false;
      }
      var chosen = !!(self.slots[self.activeSlot] && self.slots[self.activeSlot].card === c);
      c.el.classList.toggle('is-selected', chosen);
      c.el.classList.toggle('is-unavailable', !v);
      if (add) {
        add.disabled = !v;
        add.textContent = chosen ? 'Added ✓' : (v ? 'Add' : 'Unavailable');
        add.setAttribute('aria-pressed', chosen ? 'true' : 'false');
      }
    });
  };
  Mattress.prototype.choose = function (card) {
    if (!card.match) return;
    var slot = this.activeSlot;
    if (this.slots[slot] && this.slots[slot].card === card) {
      delete this.slots[slot];
      this.updateCards();
      this.render();
      this.p.updateFinance();
      return;
    }
    this.slots[slot] = { card: card, variant: card.match };
    this.setMsg('');
    this.updateCards();
    this.render();
    this.p.updateFinance();
    Drawer.close();
  };
  Mattress.prototype.remove = function (slot) {
    delete this.slots[slot];
    this.render();
    this.updateCards();
    this.p.updateFinance();
    var el = this.slotEls[slot];
    var add = el && qs('.dfp-mat-slot__add', el);
    if (add) add.focus();
  };
  Mattress.prototype.reset = function () {
    this.slots = {};
    this.render();
    this.updateCards();
  };
  Mattress.prototype.setMsg = function (text) {
    if (!this.msg) return;
    this.msg.textContent = text || '';
    this.msg.hidden = !text;
  };
  Mattress.prototype.onSizeChange = function () {
    var self = this;
    var key = normSize(this.sizeLabel());
    var dropped = [];
    this.filled().forEach(function (k) {
      var v = self.findVariant(self.slots[k].card, key);
      if (v) self.slots[k].variant = v;
      else { dropped.push(self.slots[k].card.title); delete self.slots[k]; }
    });
    this.setMsg(dropped.length ? dropped.join(', ') + ' isn’t available in this size, so it’s been removed.' : '');
    this.updateCards();
    this.render();
  };
  Mattress.prototype.render = function () {
    var self = this;
    var set = this.discountedSet();
    this.order.forEach(function (k) {
      var el = self.slotEls[k];
      if (!el) return;
      var s = self.slots[k];
      var addBtn = qs('.dfp-mat-slot__add', el);
      var chosen = qs('.dfp-mat-slot__chosen', el);
      if (addBtn) addBtn.hidden = !!s;
      if (chosen) chosen.hidden = !s;
      if (!s) return;
      var name = qs('[data-dfp-mat-slot-name]', el);
      var price = qs('[data-dfp-mat-slot-price]', el);
      var img = qs('[data-dfp-mat-slot-img]', el);
      if (name) name.textContent = s.card.title + ' – ' + prettySize(s.variant.title);
      var disc = !!set[k];
      var unit = self.unitPrice(s.variant.price, disc);
      if (price) {
        price.innerHTML = '';
        price.appendChild(document.createTextNode(self.money(unit)));
        if (disc) {
          var was = document.createElement('s');
          was.textContent = self.money(s.variant.price);
          price.appendChild(was);
        }
      }
      if (img && s.card.img) img.src = s.card.img;
    });
    this.block.classList.toggle('has-selection', this.filled().length > 0);
  };
  Mattress.prototype.filter = function (chip) {
    var group = chip.getAttribute('data-dfp-mat-filter');
    qsa('[data-dfp-mat-filter]', this.drawer).forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.cards.forEach(function (c) {
      c.el.hidden = group !== 'all' && c.el.getAttribute('data-group') !== group;
    });
  };

  /* ==========================================================================
     Product page
     ========================================================================== */
  function DFProduct(root) {
    this.root = root;
    this.observers = [];
    this.intervals = [];
    this.listeners = [];
    var json = qs('[data-dfp-json]', root);
    try { this.data = JSON.parse(json.textContent); } catch (err) { this.data = { variants: [], finance: {} }; }
    this.fmt = decodeEntities(this.data.moneyFormat || '£{{amount}}');
    this.variants = this.data.variants || [];
    this.status = this.data.status || 'live';
    this.moved = [];
    this.movePortal();

    this.form = this.data.formId ? document.getElementById(this.data.formId) : null;
    this.idInput = this.form ? qs('[data-dfp-variant-input]', this.form) : null;
    this.qtyInput = qs('[data-dfp-qty-input]', root);
    var startId = this.idInput ? parseInt(this.idInput.value, 10) : (this.variants[0] && this.variants[0].id);
    this.variant = this.findVariantById(startId) || this.variants[0] || null;
    this.selected = this.variant ? this.variant.options.slice() : [];

    var steps = ['initGallery', 'initLightbox', 'initOptions', 'initQty', 'initMattress', 'initForm', 'initFinance', 'initSticky', 'initStickyBuybox', 'initTimers', 'initDelivery', 'initPhone'];
    for (var i = 0; i < steps.length; i++) {
      try { this[steps[i]](); } catch (err) { if (window.console) console.error('[DF PDP] ' + steps[i], err); }
    }
    this.updateOptionStates();
    this.updateFinance();
  }

  DFProduct.prototype.on = function (target, type, fn, opts) {
    target.addEventListener(type, fn, opts);
    this.listeners.push([target, type, fn, opts]);
  };
  DFProduct.prototype.money = function (cents) { return formatMoney(cents, this.fmt); };
  DFProduct.prototype.findVariantById = function (id) {
    for (var i = 0; i < this.variants.length; i++) if (this.variants[i].id === id) return this.variants[i];
    return null;
  };
  DFProduct.prototype.movePortal = function () {
    var portal = qs('[data-dfp-portal]', this.root);
    if (!portal) return;
    var self = this;
    Array.prototype.slice.call(portal.children).forEach(function (el) {
      document.body.appendChild(el);
      self.moved.push(el);
    });
  };
  DFProduct.prototype.find = function (sel) {
    for (var i = 0; i < this.moved.length; i++) {
      var el = this.moved[i];
      if (el.matches && el.matches(sel)) return el;
      var inner = qs(sel, el);
      if (inner) return inner;
    }
    return qs(sel, this.root);
  };
  DFProduct.prototype.all = function (sel) {
    var out = qsa(sel, this.root);
    this.moved.forEach(function (el) {
      if (el.matches && el.matches(sel)) out.push(el);
      out = out.concat(qsa(sel, el));
    });
    return out;
  };
  DFProduct.prototype.destroy = function () {
    this.observers.forEach(function (o) { try { o.disconnect(); } catch (err) {} });
    this.intervals.forEach(function (i) { clearInterval(i); });
    this.listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    if (Drawer.current && this.moved.indexOf(Drawer.current) > -1) Drawer.close(true);
    this.moved.forEach(function (el) { if (el.parentNode) el.parentNode.removeChild(el); });
    document.documentElement.classList.remove('dfp-lock', 'dfp-hide-sticky');
    this.root.__dfp = null;
  };
  DFProduct.prototype.getQty = function () {
    var v = this.qtyInput ? parseInt(this.qtyInput.value, 10) : 1;
    if (isNaN(v) || v < 1) v = 1;
    if (v > 99) v = 99;
    return v;
  };

  /* ---------- Gallery ---------- */
  DFProduct.prototype.initGallery = function () {
    var g = qs('[data-dfp-gallery]', this.root);
    if (!g) return;
    var self = this;
    this.gallery = g;
    this.track = qs('[data-dfp-track]', g);
    this.slides = qsa('[data-dfp-slide]', g);
    this.thumbs = qsa('[data-dfp-thumb]', g);
    this.dots = qsa('[data-dfp-dot]', g);
    this.tlist = qs('[data-dfp-tlist]', g);
    this.prevBtn = qs('[data-dfp-prev]', g);
    this.nextBtn = qs('[data-dfp-next]', g);
    this.thumbUp = qs('[data-dfp-thumbs-up]', g);
    this.thumbDown = qs('[data-dfp-thumbs-down]', g);
    this.index = -1;
    if (!this.track) return;

    var initial = parseInt(this.track.getAttribute('data-initial'), 10) || 0;
    var ticking = false;
    this.on(this.track, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var w = self.track.clientWidth || 1;
        self.setActive(Math.round(self.track.scrollLeft / w));
      });
    }, { passive: true });

    this.thumbs.forEach(function (b) {
      b.addEventListener('click', function () { self.goTo(parseInt(b.getAttribute('data-dfp-thumb'), 10)); });
    });
    this.dots.forEach(function (b) {
      b.addEventListener('click', function () { self.goTo(parseInt(b.getAttribute('data-dfp-dot'), 10)); });
    });
    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.goTo(self.index + 1); });
    if (this.tlist) {
      if (this.thumbUp) this.thumbUp.addEventListener('click', function () { self.tlist.scrollBy({ top: -self.tlist.clientHeight * 0.8, behavior: behaviour(true) }); });
      if (this.thumbDown) this.thumbDown.addEventListener('click', function () { self.tlist.scrollBy({ top: self.tlist.clientHeight * 0.8, behavior: behaviour(true) }); });
      this.on(this.tlist, 'scroll', debounce(function () { self.updateThumbArrows(); }, 50), { passive: true });
    }
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index - 1); }
    });
    qsa('[data-dfp-zoom]', g).forEach(function (b) {
      b.addEventListener('click', function () { self.openLightbox(parseInt(b.getAttribute('data-dfp-zoom'), 10)); });
    });
    this.on(window, 'resize', debounce(function () {
      if (self.index > -1) self.track.scrollTo({ left: self.index * self.track.clientWidth, behavior: 'auto' });
      self.updateThumbArrows();
    }, 120));

    this.setActive(initial);
    if (initial > 0) {
      requestAnimationFrame(function () { self.track.scrollTo({ left: initial * self.track.clientWidth, behavior: 'auto' }); });
    }
    setTimeout(function () { self.updateThumbArrows(); }, 300);
  };
  DFProduct.prototype.goTo = function (i, smooth) {
    if (!this.track || !this.slides.length) return;
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: behaviour(smooth) });
    this.setActive(i);
  };
  DFProduct.prototype.setActive = function (i) {
    if (!this.slides || !this.slides.length) return;
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    if (i === this.index) return;
    var prevIndex = this.index;
    this.index = i;
    this.thumbs.forEach(function (t, n) {
      var on = n === i;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    this.dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    if (this.prevBtn) this.prevBtn.disabled = i === 0;
    if (this.nextBtn) this.nextBtn.disabled = i === this.slides.length - 1;
    var t = this.thumbs[i];
    if (t && this.tlist && this.tlist.clientHeight) {
      var top = t.offsetTop;
      if (top < this.tlist.scrollTop) this.tlist.scrollTo({ top: Math.max(0, top - 4), behavior: behaviour(true) });
      else if (top + t.offsetHeight > this.tlist.scrollTop + this.tlist.clientHeight) this.tlist.scrollTo({ top: top + t.offsetHeight - this.tlist.clientHeight + 4, behavior: behaviour(true) });
    }
    if (prevIndex > -1 && this.slides[prevIndex]) {
      qsa('video', this.slides[prevIndex]).forEach(function (v) { try { v.pause(); } catch (err) {} });
    }
  };
  DFProduct.prototype.updateThumbArrows = function () {
    if (!this.tlist) return;
    var atTop = this.tlist.scrollTop <= 2;
    var atBottom = this.tlist.scrollTop + this.tlist.clientHeight >= this.tlist.scrollHeight - 2;
    if (this.thumbUp) this.thumbUp.disabled = atTop;
    if (this.thumbDown) this.thumbDown.disabled = atBottom;
  };

  /* ---------- Lightbox ---------- */
  DFProduct.prototype.initLightbox = function () {
    var lb = this.find('[data-dfp-lightbox]');
    if (!lb) return;
    var self = this;
    this.lb = lb;
    this.lbTrack = qs('[data-dfp-lb-track]', lb);
    this.lbSlides = qsa('[data-dfp-lb-slide]', lb);
    this.lbThumbs = qsa('[data-dfp-lb-thumb]', lb);
    this.lbTlist = qs('[data-dfp-lb-tlist]', lb);
    this.lbCount = qs('[data-dfp-lb-count]', lb);
    this.lbIndex = 0;
    var closeBtn = qs('[data-dfp-lb-close]', lb);
    if (closeBtn) closeBtn.addEventListener('click', function () { self.closeLightbox(); });
    var prev = qs('[data-dfp-lb-prev]', lb), next = qs('[data-dfp-lb-next]', lb);
    if (prev) prev.addEventListener('click', function () { self.lbGo(self.lbIndex - 1); });
    if (next) next.addEventListener('click', function () { self.lbGo(self.lbIndex + 1); });
    this.lbThumbs.forEach(function (b) {
      b.addEventListener('click', function () { self.lbGo(parseInt(b.getAttribute('data-dfp-lb-thumb'), 10)); });
    });
    var tprev = qs('[data-dfp-lb-tprev]', lb), tnext = qs('[data-dfp-lb-tnext]', lb);
    if (tprev && this.lbTlist) tprev.addEventListener('click', function () { self.lbTlist.scrollBy({ left: -self.lbTlist.clientWidth * 0.8, behavior: behaviour(true) }); });
    if (tnext && this.lbTlist) tnext.addEventListener('click', function () { self.lbTlist.scrollBy({ left: self.lbTlist.clientWidth * 0.8, behavior: behaviour(true) }); });
    var ticking = false;
    if (this.lbTrack) {
      this.lbTrack.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var w = self.lbTrack.clientWidth || 1;
          self.lbSetActive(Math.round(self.lbTrack.scrollLeft / w));
        });
      }, { passive: true });
      this.lbTrack.addEventListener('click', function (e) {
        if (e.target === self.lbTrack || e.target.classList.contains('dfp-lightbox__slide')) self.closeLightbox();
      });
    }
    this.lbKey = function (e) {
      if (!Lightbox.isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); self.closeLightbox(); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); self.lbGo(self.lbIndex + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.lbGo(self.lbIndex - 1); }
      else if (e.key === 'Tab') trapTab(e, lb);
    };
  };
  DFProduct.prototype.openLightbox = function (i) {
    if (!this.lb) return;
    var self = this;
    this.lbOpener = document.activeElement;
    this.lb.classList.add('is-open');
    this.lb.setAttribute('aria-hidden', 'false');
    Lightbox.isOpen = true;
    lockScroll(true);
    document.addEventListener('keydown', this.lbKey);
    requestAnimationFrame(function () {
      self.lbGo(i, false);
      var c = qs('[data-dfp-lb-close]', self.lb);
      if (c) { try { c.focus({ preventScroll: true }); } catch (err) { c.focus(); } }
    });
  };
  DFProduct.prototype.closeLightbox = function () {
    if (!this.lb || !Lightbox.isOpen) return;
    this.lb.classList.remove('is-open');
    this.lb.setAttribute('aria-hidden', 'true');
    Lightbox.isOpen = false;
    if (!Drawer.current) lockScroll(false);
    document.removeEventListener('keydown', this.lbKey);
    this.goTo(this.lbIndex, false);
    if (this.lbOpener && this.lbOpener.focus) { try { this.lbOpener.focus({ preventScroll: true }); } catch (err) {} }
  };
  DFProduct.prototype.lbGo = function (i, smooth) {
    if (!this.lbTrack || !this.lbSlides.length) return;
    i = Math.max(0, Math.min(this.lbSlides.length - 1, i));
    this.lbTrack.scrollTo({ left: i * this.lbTrack.clientWidth, behavior: behaviour(smooth) });
    this.lbSetActive(i);
  };
  DFProduct.prototype.lbSetActive = function (i) {
    i = Math.max(0, Math.min(this.lbSlides.length - 1, i));
    this.lbIndex = i;
    var self = this;
    this.lbThumbs.forEach(function (t, n) {
      var on = n === i;
      t.classList.toggle('is-active', on);
      if (on && self.lbTlist) {
        var left = t.offsetLeft - self.lbTlist.offsetLeft;
        if (left < self.lbTlist.scrollLeft || left + t.offsetWidth > self.lbTlist.scrollLeft + self.lbTlist.clientWidth) {
          self.lbTlist.scrollTo({ left: Math.max(0, left - self.lbTlist.clientWidth / 2 + t.offsetWidth / 2), behavior: behaviour(true) });
        }
      }
    });
    if (this.lbCount) this.lbCount.textContent = (i + 1) + ' / ' + this.lbSlides.length;
  };

  /* ---------- Options / variants ---------- */
  DFProduct.prototype.initOptions = function () {
    var self = this;
    this.optionSets = qsa('[data-dfp-option]', this.root);
    this.optionSets.forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-dfp-option'), 10);
      qsa('[data-dfp-opt]', fs).forEach(function (btn) {
        btn.addEventListener('click', function () { self.selectOption(idx, btn.getAttribute('data-value')); });
      });
    });
  };
  DFProduct.prototype.matchVariant = function (sel) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      var ok = true;
      for (var j = 0; j < v.options.length; j++) if (v.options[j] !== sel[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  };
  DFProduct.prototype.selectOption = function (idx, value) {
    var sel = this.selected.slice();
    sel[idx] = value;
    var v = this.matchVariant(sel);
    if (!v || !v.available) {
      var best = null, bestScore = -1;
      this.variants.forEach(function (x) {
        if (x.options[idx] !== value || !x.available) return;
        var score = 0;
        x.options.forEach(function (o, j) { if (o === sel[j]) score++; });
        if (score > bestScore) { best = x; bestScore = score; }
      });
      if (best) v = best;
      else if (!v) v = this.variants.filter(function (x) { return x.options[idx] === value; })[0] || null;
    }
    if (v) this.setVariant(v);
  };
  DFProduct.prototype.setVariant = function (v) {
    var self = this;
    this.variant = v;
    this.selected = v.options.slice();
    if (this.idInput) {
      this.idInput.value = v.id;
      this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.optionSets.forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-dfp-option'), 10);
      var val = self.selected[idx];
      qsa('[data-dfp-opt]', fs).forEach(function (b) {
        var on = b.getAttribute('data-value') === val;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var lbl = qs('[data-dfp-option-selected]', fs);
      if (lbl) lbl.textContent = val;
    });
    this.updateOptionStates();
    this.updatePrice();
    this.updateStock();
    this.updateATC();
    if (window.history && history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (err) {}
    }
    if (v.media && this.slides) {
      for (var i = 0; i < this.slides.length; i++) {
        if (parseInt(this.slides[i].getAttribute('data-media-id'), 10) === v.media) { this.goTo(i); break; }
      }
    }
    if (this.mattress) this.mattress.onSizeChange();
    this.updateFinance();
    this.root.dispatchEvent(new CustomEvent('dfp:variant', { bubbles: true, detail: { variant: v } }));
  };
  DFProduct.prototype.updateOptionStates = function () {
    var self = this;
    if (!this.optionSets) return;
    this.optionSets.forEach(function (fs) {
      var idx = parseInt(fs.getAttribute('data-dfp-option'), 10);
      qsa('[data-dfp-opt]', fs).forEach(function (b) {
        var val = b.getAttribute('data-value');
        var available = self.variants.some(function (v) {
          if (!v.available || v.options[idx] !== val) return false;
          for (var j = 0; j < v.options.length; j++) if (j !== idx && v.options[j] !== self.selected[j]) return false;
          return true;
        });
        b.classList.toggle('is-unavailable', !available);
      });
    });
  };
  DFProduct.prototype.updatePrice = function () {
    var self = this;
    var v = this.variant;
    if (!v) return;
    var onSale = v.compare > v.price;
    this.all('[data-dfp-price-now]').forEach(function (el) { el.textContent = self.money(v.price); });
    this.all('[data-dfp-price-was]').forEach(function (el) {
      el.hidden = !onSale;
      var s = qs('[data-dfp-price-was-value]', el);
      if (s && onSale) s.textContent = self.money(v.compare);
    });
    this.all('[data-dfp-price-save]').forEach(function (el) {
      el.hidden = !onSale;
      if (onSale) el.textContent = 'Save ' + moneyShort(v.compare - v.price, self.fmt);
    });
    this.all('[data-dfp-price-wrap]').forEach(function (el) { el.classList.toggle('is-sale', onSale); });
  };
  DFProduct.prototype.updateStock = function () {
    var badge = qs('[data-dfp-stock]', this.root);
    if (!badge || !this.variant) return;
    var state, text;
    if (!this.variant.available) { state = 'soldout'; text = 'Sold out'; }
    else if (this.status === 'mto') { state = 'live'; text = this.data.mtoBadge || 'Made to order'; }
    else if (this.status === 'reserve') { state = 'reserve'; text = 'Reserve yours'; }
    else { state = 'live'; text = 'In stock'; }
    badge.className = 'dfp-stock dfp-stock--' + state;
    var t = qs('[data-dfp-stock-text]', badge);
    if (t) t.textContent = text;
  };
  DFProduct.prototype.updateATC = function () {
    var self = this;
    var ok = !!(this.variant && this.variant.available);
    this.all('[data-dfp-atc], [data-dfp-sticky-atc]').forEach(function (b) {
      b.disabled = !ok;
      var l = qs('[data-dfp-atc-label]', b);
      if (l) l.textContent = ok ? (self.data.atcLabel || 'Add to Basket') : 'Sold out';
    });
  };

  /* ---------- Quantity ---------- */
  DFProduct.prototype.initQty = function () {
    var self = this;
    var wrap = qs('[data-dfp-qty]', this.root);
    if (!wrap || !this.qtyInput) return;
    var input = this.qtyInput;
    var set = function (n) {
      input.value = Math.max(1, Math.min(99, n));
      self.onQtyChange();
    };
    var minus = qs('[data-dfp-qty-minus]', wrap), plus = qs('[data-dfp-qty-plus]', wrap);
    if (minus) minus.addEventListener('click', function () { set(self.getQty() - 1); });
    if (plus) plus.addEventListener('click', function () { set(self.getQty() + 1); });
    input.addEventListener('change', function () { set(self.getQty()); });
    input.addEventListener('input', function () { if (input.value !== '') self.onQtyChange(); });
  };
  DFProduct.prototype.onQtyChange = function () {
    if (this.mattress) { this.mattress.render(); this.mattress.updateCards(); }
    this.updateFinance();
  };

  /* ---------- Mattress ---------- */
  DFProduct.prototype.initMattress = function () {
    var block = qs('[data-dfp-mat]', this.root);
    if (!block) return;
    var drawer = document.getElementById('dfp-mat-' + block.getAttribute('data-dfp-mat'));
    if (!drawer) { block.hidden = true; return; }
    this.mattress = new Mattress(this, block, drawer);
  };

  /* ---------- Add to basket ---------- */
  DFProduct.prototype.initForm = function () {
    if (!this.form) return;
    var self = this;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.addToCart(e.submitter || qs('[data-dfp-atc]', self.form));
    });
  };
  DFProduct.prototype.setBusy = function (on) {
    this.busy = on;
    this.all('[data-dfp-atc], [data-dfp-sticky-atc]').forEach(function (b) {
      b.classList.toggle('is-loading', on);
      if (on) b.setAttribute('aria-busy', 'true'); else b.removeAttribute('aria-busy');
    });
  };
  DFProduct.prototype.showError = function (msg) {
    var el = qs('[data-dfp-error]', this.root);
    if (!el) { if (msg && window.console) console.warn('[DF PDP] ' + msg); return; }
    el.textContent = msg || '';
    el.hidden = !msg;
  };
  DFProduct.prototype.addToCart = function (btn) {
    var self = this;
    if (this.busy || !this.variant || !this.variant.available) return;
    var qty = this.getQty();
    var items = [{ id: this.variant.id, quantity: qty }];
    if (this.mattress) items = items.concat(this.mattress.items(qty));
    var sections = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(function (el) { return el && el.dataset && el.dataset.sectionId; });
    var body = { items: items };
    if (sections.length) {
      body.sections = sections.map(function (el) { return el.dataset.sectionId; }).join(',');
      body.sections_url = window.location.pathname;
    }
    var routes = (window.theme && window.theme.routes) || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = routes.cartAdd || (root + 'cart/add.js');
    this.setBusy(true);
    this.showError('');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data || {} }; }, function () { return { ok: r.ok, data: {} }; });
      })
      .then(function (res) {
        var data = res.data;
        if (!res.ok || data.status) {
          var m = typeof data.description === 'string' ? data.description : (data.message || 'Sorry, we couldn’t add that to your basket. Please try again.');
          throw new Error(m);
        }
        var afterAdd = window.theme && window.theme.settings ? window.theme.settings.afterAddToCart : 'drawer';
        if (afterAdd === 'page') { window.location.href = routes.cart || (root + 'cart'); return; }
        var updated = false;
        if (data.sections && sections.length) {
          updated = sections.every(function (el) { return !!data.sections[el.dataset.sectionId]; });
          if (updated) {
            sections.forEach(function (el) {
              try { if (typeof el.updateFromCartChange === 'function') el.updateFromCartChange(data.sections[el.dataset.sectionId]); } catch (err) { updated = false; }
            });
          }
        }
        if (!updated) document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        var drawer = document.querySelector('.js-cart-drawer');
        if (drawer && typeof drawer.open === 'function' && afterAdd !== 'notification') drawer.open(btn);
        (self.form || document).dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: self.variant.id } }));
        if (self.mattress) self.mattress.reset();
        self.updateFinance();
      })
      .catch(function (err) {
        self.showError(err && err.message ? err.message : 'Sorry, something went wrong.');
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        var errEl = qs('[data-dfp-error]', self.root);
        if (errEl && errEl.getBoundingClientRect().top < 0) scrollToEl(errEl);
      })
      .then(function () { self.setBusy(false); });
  };

  /* ---------- Finance (PayItMonthly) ---------- */
  DFProduct.prototype.initFinance = function () {
    var d = document.getElementById('dfp-finance-' + this.data.sectionId);
    if (!d) return;
    var self = this;
    this.finDrawer = d;
    this.fin = {
      months: qs('[data-dfp-fin-months]', d),
      monthsOut: qs('[data-dfp-fin-months-out]', d),
      today: qs('[data-dfp-fin-today]', d),
      todayOut: qs('[data-dfp-fin-today-out]', d),
      monthly: qs('[data-dfp-fin-monthly]', d),
      then: qs('[data-dfp-fin-then]', d),
      todayVal: qs('[data-dfp-fin-today-val]', d),
      totalVal: qs('[data-dfp-fin-total-val]', d),
      example: qs('[data-dfp-fin-example]', d),
      total: qs('[data-dfp-fin-total]', d),
      inel: qs('[data-dfp-fin-ineligible]', d),
      calc: qs('[data-dfp-fin-calc]', d)
    };
    if (this.fin.months) this.fin.months.addEventListener('input', function () { self.updateCalc(true); });
    if (this.fin.today) this.fin.today.addEventListener('input', function () { self.updateCalc(false); });
    d.addEventListener('dfp:drawer:open', function () { self.updateCalc(true); });
  };
  DFProduct.prototype.selectionTotal = function () {
    var q = this.getQty();
    return (this.variant ? this.variant.price * q : 0) + (this.mattress ? this.mattress.total(q) : 0);
  };
  DFProduct.prototype.updateFinance = function () {
    var f = this.data.finance || {};
    if (!f.enabled) return;
    var self = this;
    var total = this.selectionTotal();
    var ok = total >= f.min && total <= f.max;
    var from = Math.floor(total / (f.months || 12));
    this.all('[data-dfp-fin-amount]').forEach(function (el) { el.textContent = self.money(from); });
    this.all('[data-dfp-fin-line]').forEach(function (el) { el.hidden = !ok; });
    this.all('[data-dfp-fin-box]').forEach(function (el) { el.hidden = !ok; });
    this.all('[data-dfp-fin-min]').forEach(function (el) { el.hidden = ok; });
    if (this.finDrawer) this.updateCalc(false);
  };
  DFProduct.prototype.updateCalc = function (resetToday) {
    var f = this.data.finance || {};
    var F = this.fin;
    if (!F) return;
    var total = this.selectionTotal();
    var ok = total >= f.min && total <= f.max;
    if (F.total) F.total.textContent = this.money(total);
    if (F.inel) F.inel.hidden = ok;
    if (F.calc) F.calc.hidden = !ok;
    if (!ok || !F.months || !F.today) return;
    var m = parseInt(F.months.value, 10) || f.months;
    var minToday = Math.round(total / m);
    F.today.min = String(minToday);
    F.today.max = String(total);
    F.today.step = '100';
    var t = parseInt(F.today.value, 10);
    if (resetToday || isNaN(t) || t < minToday) t = minToday;
    if (t > total) t = total;
    F.today.value = String(t);
    t = parseInt(F.today.value, 10);
    if (isNaN(t) || t < minToday) t = minToday;
    var rest = m - 1;
    var monthly = rest > 0 ? Math.round((total - t) / rest) : 0;
    if (F.monthsOut) F.monthsOut.textContent = m + ' months';
    if (F.todayOut) F.todayOut.textContent = this.money(t);
    if (F.monthly) F.monthly.textContent = this.money(monthly);
    if (F.then) F.then.textContent = rest > 0 ? 'Then ' + this.money(monthly) + ' × ' + rest : 'Paid in full today';
    if (F.todayVal) F.todayVal.textContent = this.money(t);
    if (F.totalVal) F.totalVal.textContent = this.money(total);
    if (F.example) {
      var exM = f.months || 12;
      var exToday = Math.round(total / exM);
      var exMonthly = exM > 1 ? Math.round((total - exToday) / (exM - 1)) : 0;
      F.example.textContent = 'Representative example: if you spend ' + this.money(total) + ' over ' + exM + ' months, you pay ' + this.money(exToday) +
        ' today followed by ' + (exM - 1) + ' monthly payments of ' + this.money(exMonthly) + '. Total payable ' + this.money(total) + '. 0% interest.';
    }
  };

  /* ---------- Sticky Add-to-Basket bar ---------- */
  DFProduct.prototype.initSticky = function () {
    var bar = this.find('[data-dfp-sticky]');
    var atc = qs('[data-dfp-atc]', this.root);
    if (!bar || !atc) return;
    var self = this;
    this.stickyBar = bar;
    // Scroll-position check (rAF-throttled) rather than IntersectionObserver alone: an observer
    // never fires when a fast fling, anchor jump or restored scroll position skips over the button.
    var ticking = false;
    var check = function () {
      ticking = false;
      var r = atc.getBoundingClientRect();
      self.toggleSticky(r.height > 0 && r.bottom < stickyHeaderHeight());
    };
    var queue = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(check); } };
    this.on(window, 'scroll', queue, { passive: true });
    this.on(window, 'resize', queue);
    queue();
    setTimeout(queue, 600);
    var hide = function () { document.documentElement.classList.add('dfp-hide-sticky'); };
    var show = function () { document.documentElement.classList.remove('dfp-hide-sticky'); };
    this.on(document, 'on:cart-drawer:before-open', hide);
    this.on(document, 'on:cart-drawer:after-close', show);
    this.on(document, 'on:cart-drawer:before-close', show);
  };
  DFProduct.prototype.toggleSticky = function (show) {
    var bar = this.stickyBar;
    if (!bar) return;
    if (bar.classList.contains('is-visible') === show) return;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    qsa('a, button', bar).forEach(function (el) { el.tabIndex = show ? 0 : -1; });
    document.documentElement.classList.toggle('dfp-sticky-on', show);
  };

  /* ---------- Sticky buy box (tall boxes stick by their bottom edge) ---------- */
  DFProduct.prototype.initStickyBuybox = function () {
    var box = qs('.dfp-buybox--sticky', this.root);
    if (!box) return;
    var calc = function () {
      if (window.innerWidth < 990) { box.style.top = ''; return; }
      var offset = stickyHeaderHeight() + 20;
      var vh = window.innerHeight;
      var h = box.offsetHeight;
      box.style.top = (h + offset + 20 > vh ? Math.min(offset, vh - h - 24) : offset) + 'px';
    };
    var dcalc = debounce(calc, 60);
    calc();
    this.on(window, 'resize', dcalc);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(dcalc);
      ro.observe(box);
      this.observers.push(ro);
    }
    setTimeout(calc, 800);
  };

  /* ---------- Offer countdown (genuine end dates only) ---------- */
  DFProduct.prototype.initTimers = function () {
    var self = this;
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    qsa('[data-dfp-timer]', this.root).forEach(function (el) {
      var end = parseInt(el.getAttribute('data-end'), 10) * 1000;
      if (!end) { el.hidden = true; return; }
      var dWrap = qs('[data-dfp-timer-dwrap]', el), d = qs('[data-dfp-timer-d]', el);
      var h = qs('[data-dfp-timer-h]', el), m = qs('[data-dfp-timer-m]', el), s = qs('[data-dfp-timer-s]', el);
      var iv;
      var tick = function () {
        var diff = end - Date.now();
        if (diff <= 0) { el.hidden = true; clearInterval(iv); return; }
        var sec = Math.floor(diff / 1000);
        var days = Math.floor(sec / 86400);
        if (dWrap) dWrap.hidden = days === 0;
        if (d) d.textContent = days;
        if (h) h.textContent = pad(Math.floor((sec % 86400) / 3600));
        if (m) m.textContent = pad(Math.floor((sec % 3600) / 60));
        if (s) s.textContent = pad(sec % 60);
      };
      tick();
      iv = setInterval(tick, 1000);
      self.intervals.push(iv);
    });
  };

  /* ---------- Delivery estimate (refresh for cached pages) ---------- */
  DFProduct.prototype.initDelivery = function () {
    var iso = this.data.restock;
    if (!iso) return;
    var parts = iso.split('-');
    if (parts.length !== 3) return;
    var target = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10), 12, 0, 0);
    var days = (target.getTime() - Date.now()) / 86400000;
    var lead;
    if (days <= 0) {
      this.status = 'live';
      lead = this.data.isBespoke ? '2–4 weeks' : '2–7 working days';
    } else {
      var weeks = days / 7;
      var low = Math.max(1, Math.floor(weeks));
      var high = low + 2;
      if (weeks < 2.2) { low = 1; high = 2; }
      lead = low + '–' + high + ' weeks';
    }
    this.all('[data-dfp-delivery-lead]').forEach(function (el) { el.textContent = lead; });
    this.updateStock();
  };

  /* ---------- Order by phone (Klaviyo form) ---------- */
  DFProduct.prototype.initPhone = function () {
    var self = this;
    this.moved.filter(function (el) { return el.matches && el.matches('[data-dfp-phone]'); }).forEach(function (drawer) {
      var wrap = qs('[data-dfp-klaviyo]', drawer);
      var hp = qs('[data-dfp-honeypot]', drawer);
      var spam = qs('[data-dfp-phone-spam]', drawer);
      var inject = function () {
        var form = wrap && qs('form', wrap);
        if (!form) return false;
        var v = self.variant;
        [['page_url', window.location.href], ['product_title', self.data.productTitle || ''], ['variant_id', v ? String(v.id) : ''], ['variant_price', v ? self.money(v.price) : '']].forEach(function (pair) {
          var input = form.querySelector('input[name="' + pair[0] + '"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = pair[0];
            form.appendChild(input);
          }
          input.value = pair[1];
        });
        return true;
      };
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (inject() || tries > 80) clearInterval(iv);
      }, 250);
      self.intervals.push(iv);
      drawer.addEventListener('dfp:drawer:open', function () { setTimeout(inject, 300); setTimeout(inject, 1000); });
      self.on(self.root, 'dfp:variant', inject);
      self.on(document, 'submit', function (e) {
        if (!wrap || !wrap.contains(e.target)) return;
        if (hp && hp.value.trim() !== '') {
          e.preventDefault();
          e.stopPropagation();
          if (spam) spam.hidden = false;
        }
      }, true);
    });
  };

  /* ==========================================================================
     Recommendations carousel
     ========================================================================== */
  function initCarousel(sec) {
    var track = qs('[data-dfc-track]', sec);
    if (!track) return;
    var prev = qs('[data-dfc-prev]', sec), next = qs('[data-dfc-next]', sec), dotsWrap = qs('[data-dfc-dots]', sec);
    var pages = function () { return Math.max(1, Math.round(track.scrollWidth / Math.max(1, track.clientWidth))); };
    var build = function () {
      if (!dotsWrap) return;
      var n = pages();
      dotsWrap.innerHTML = '';
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dfc__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (idx) { b.addEventListener('click', function () { track.scrollTo({ left: idx * track.clientWidth, behavior: behaviour(true) }); }); })(i);
        dotsWrap.appendChild(b);
      }
      update();
    };
    var update = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
      var controls = qs('.dfc__controls', sec);
      if (controls) controls.hidden = track.scrollWidth <= track.clientWidth + 2;
      if (dotsWrap) {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        qsa('.dfc__dot', dotsWrap).forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      }
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: behaviour(true) }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: behaviour(true) }); });
    track.addEventListener('scroll', debounce(update, 40), { passive: true });
    window.addEventListener('resize', debounce(build, 150));
    build();
    update();
  }

  function initRecs(scope) {
    qsa('[data-dfc]', scope).forEach(function (sec) {
      if (sec.__dfc) return;
      sec.__dfc = true;
      var url = sec.getAttribute('data-url');
      if (!url) { if (qs('.dfc__item', sec)) initCarousel(sec); return; }
      var load = function () {
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var fresh = tmp.querySelector('[data-dfc-inner]');
            var target = qs('[data-dfc-inner]', sec);
            if (fresh && target && fresh.querySelector('.dfc__item')) {
              target.innerHTML = fresh.innerHTML;
              sec.hidden = false;
              initCarousel(sec);
              document.dispatchEvent(new CustomEvent('dfp:recs:loaded', { detail: { section: sec } }));
            } else {
              sec.hidden = true;
            }
          })
          .catch(function () { sec.hidden = true; });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '800px 0px' });
        // a [hidden] element never intersects, so watch its (always rendered) section wrapper instead
        io.observe(sec.hidden && sec.parentElement ? sec.parentElement : sec);
      } else {
        load();
      }
    });
  }

  /* ==========================================================================
     Why buy accordion (one open at a time; fallback for <details name>)
     ========================================================================== */
  function initWhyBuy(scope) {
    qsa('[data-dfy]', scope).forEach(function (wrap) {
      if (wrap.__dfy) return;
      wrap.__dfy = true;
      var items = qsa('details', wrap);
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        });
      });
    });
  }

  /* ==========================================================================
     Boot
     ========================================================================== */
  function boot(scope) {
    scope = scope || document;
    qsa('[data-dfp-root]', scope).forEach(function (root) {
      if (root.__dfp) return;
      try { root.__dfp = new DFProduct(root); } catch (err) { if (window.console) console.error('[DF PDP]', err); }
    });
    initRecs(scope);
    initWhyBuy(scope);
  }

  document.addEventListener('shopify:section:unload', function (e) {
    qsa('[data-dfp-root]', e.target).forEach(function (root) { if (root.__dfp) root.__dfp.destroy(); });
  });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (b && b.matches && b.matches('[data-dfp-open]')) {
      var d = document.getElementById(b.getAttribute('data-dfp-open'));
      if (d) Drawer.open(d, b);
    }
  });
  document.addEventListener('shopify:block:deselect', function () { if (Drawer.current) Drawer.close(true); });

  window.DFPDP = { boot: boot, drawer: Drawer, formatMoney: formatMoney };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
})();
